import React, { useRef, useState, useEffect } from 'react'
import { dataObj, dataObjKeys } from './examData'
import './CareerPath.css';
import Swal from "sweetalert2";
import axios from 'axios';
import CareerTestResult from './CareerTestResult';
import { BASE_URL } from "../../utils/constants";


function CareerPath() {
    // data object reference
    const listOfQuestions = useRef()
    // array of keys reference
    const listOfKeys = useRef()

    // current key like R1,A2,I3, etc...
    // used to fetch from listOfQuestions reference
    const currQKey = useRef()

    // current index of chosen key
    // used to select from dataObjeKeys
    const currQIndex = useRef()

    // finalResult to Submit
    const finalResult = useRef()

    // finalResult to Submit
    const mytopEle = useRef(null)

    const [currQTitle, setCurrQTitle] = useState('');
    const [testResult, setTestResult] = useState(null);

    const shuffledArr = (arr) => {
        const newArr = arr.slice()
        for (let i = newArr.length - 1; i > 0; i--) {
            const rand = Math.floor(Math.random() * (i + 1));
            [newArr[i], newArr[rand]] = [newArr[rand], newArr[i]];
        }
        return newArr
    };

    const sortedObject = (reqObj) => Object.entries(reqObj)
        .sort(([, a], [, b]) => b - a)
        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});

    useEffect(() => {

        Swal.showLoading();
        axios.post(`${BASE_URL}/exam/submitcareerpath.php`,
            {
                checkuser: 'checkuser',
                testname: 'careerpath'
            })
            .then(res => {

                if (res.data.data) {
                    setTestResult(res.data.data);
                    Swal.close();
                }
                // else {
                currQIndex.current = 0
                listOfQuestions.current = dataObj
                listOfKeys.current = shuffledArr(dataObjKeys)
                // listOfKeys.current = dataObjKeys
                currQKey.current = listOfKeys.current[currQIndex.current]

                finalResult.current = {
                    "R": 0,
                    "I": 0,
                    "A": 0,
                    "S": 0,
                    "E": 0,
                    "C": 0
                }
                Swal.close();
                setCurrQTitle(listOfQuestions.current[currQKey.current])
                // }
            })
            .catch(err => {

                Swal.fire('Process Failed', '', 'error');
            })

    }, [])

    function scrollToTop() {
        if (mytopEle.current !== null) {
            mytopEle.current.scrollIntoView({ behavior: "smooth" });
        }
    }


    const selectAnswer = (e, answerVal) => {
        e.preventDefault()

        finalResult.current[currQKey.current[0]] = finalResult.current[currQKey.current[0]] += answerVal


        if (currQIndex.current == (listOfKeys.current.length - 1)) {
            Swal.showLoading();
            let orderedResult = sortedObject(finalResult.current)
            let resultToSubmit = Object.keys(orderedResult)[0] + Object.keys(orderedResult)[1] + Object.keys(orderedResult)[2]
            axios.post(`${BASE_URL}/exam/submitcareerpath.php`,
                {
                    R: finalResult.current['R'],
                    I: finalResult.current['I'],
                    A: finalResult.current['A'],
                    S: finalResult.current['S'],
                    E: finalResult.current['E'],
                    C: finalResult.current['C'],
                    result: resultToSubmit,
                    testname: 'careerpath'
                })
                .then(res => {

                    Swal.fire('Test Submitted Successfully', '', 'success')
                        .then(() => {
                            setTestResult(res.data.data);
                        })
                })
                .catch(err => {

                    Swal.fire('Submission Failed', '', 'error');
                })
        } else {
            currQIndex.current += 1;
            currQKey.current = listOfKeys.current[currQIndex.current]
            setCurrQTitle(listOfQuestions.current[currQKey.current])
        }
    }
    return (
        <>
            <div ref={mytopEle} style={{ display: "block", height: '2px' }} />

            {testResult ?
                (<div className='careerPath__viewTestResults' >
                    <>

                        <CareerTestResult studentScore={testResult} />
                        <div className='' style={{ marginTop: "20px", marginBottom: "20px", textAlign: "left" }}>
                            <button style={{ background: "orange", color: "#000", padding: "10px 15px", borderRadius: '10px', marginTop: "15px", fontWeight: "bold", marginRight: "auto" }} onClick={() => {
                                setTestResult(null);
                                scrollToTop()
                            }}>Retake the test</button>
                        </div>
                    </>
                </div>
                )

                : (
                    <div className='careerPath__container'>

                        <div className='careerPath__inner'>
                            <div className='careerPath__qTitle'>
                                <h4>Q : {currQTitle}</h4>
                            </div>
                            <div className='careerPath__formField'>
                                <label className="ans_button" onClick={(e) => { selectAnswer(e, 0) }}>
                                    <input type="radio" name="Q" id="A1" />&nbsp;Dislike
                                </label>
                            </div>
                            <div className='careerPath__formField'>
                                <label className="ans_button" onClick={(e) => { selectAnswer(e, 1) }}>
                                    <input type="radio" name="Q" id="A2" />&nbsp;Slightly Dislike
                                </label>
                            </div>
                            <div className='careerPath__formField'>
                                <label className="ans_button" onClick={(e) => { selectAnswer(e, 2) }}>
                                    <input type="radio" name="Q" id="A3" />&nbsp;Neutral
                                </label>
                            </div>
                            <div className='careerPath__formField'>
                                <label className="ans_button" onClick={(e) => { selectAnswer(e, 3) }}>
                                    <input type="radio" name="Q" id="A4" />&nbsp;Slightly Enjoy
                                </label>
                            </div>
                            <div className='careerPath__formField'>
                                <label className="ans_button" onClick={(e) => { selectAnswer(e, 4) }}>
                                    <input type="radio" name="Q" id="A5" />&nbsp;Enjoy
                                </label>
                            </div>

                            <div className='careerPath__qNo'>
                                <h5>{currQIndex.current ? currQIndex.current + 1 : 1}/{listOfKeys.current && listOfKeys.current.length}</h5>
                            </div>
                        </div>
                    </div>
                )


            }
        </>

    )
}

export default CareerPath